import { Box, Paper, Tab, Tabs } from "@mui/material";
import React from "react";
import CategoryTitle from "../atoms/CategoryTitle";
import StoreAdjustmentDaily from "./StoreAdjustmentDaily";
import StoreAdjustmentMonthly from "./StoreAdjustmentMonthly";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    id: string;
    ariaLabelledby: string;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, id, ariaLabelledby, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={id}
            aria-labelledby={ariaLabelledby}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const StoreDetailAdjustment: React.FC = () => {
    const [selectedTab, setSelectedTab] = React.useState<number>(0)

    return (
        <Paper sx={{ mt: 2, pb: 2 }}>
            <CategoryTitle
                text="売上一覧"
            />
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            >
                <Tabs
                    value={selectedTab}
                    onChange={(event, value) => {
                        setSelectedTab(value)
                    }}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab
                        label="日別合計"
                        sx={{
                            textTransform: "none",
                        }}
                        id="store-adjustment-tab-daily"
                        aria-controls="store-adjustment-tabpanel-daily"
                    />
                    <Tab
                        label="月別合計"
                        sx={{
                            textTransform: "none",
                        }}
                        id="store-adjustment-tab-monthly"
                        aria-controls="store-adjustment-tabpanel-monthly"
                    />
                </Tabs>
            </Box>
            <Box>
                <TabPanel
                    index={0}
                    value={selectedTab}
                    id="store-adjustment-tab-daily"
                    ariaLabelledby="store-adjustment-tabpanel-daily"
                >
                    <StoreAdjustmentDaily />
                </TabPanel>
                <TabPanel
                    index={1}
                    value={selectedTab}
                    id="store-adjustment-tab-monthly"
                    ariaLabelledby="store-adjustment-tabpanel-monthly"
                >
                    <StoreAdjustmentMonthly />
                </TabPanel>
            </Box>
        </Paper>
    );
}

export default StoreDetailAdjustment